import { createContext } from 'react'
import { SitewideMessageContextProps } from './SitewideMessageContext.types'

const defaultSitewideMessageContext = {
  shouldShowSitewideMessage: false,
  closeSitewideMessage: () => undefined
}

export const SitewideMessageContext = createContext<SitewideMessageContextProps>(defaultSitewideMessageContext)
